export const transWord = {
  navBar: {
    li1: {
      cn: "关于我们",
      en: "About Us",
    },
    li2: {
      cn: "产品与方案",
      en: "Products & Solutions",
    },
    li3: {
      cn: "服务与案例",
      en: "Services & Cases",
    },
    li4: {
      cn: "合作伙伴",
      en: "Partners",
    },
    li6: {
      cn: "服务热线：4008206925",
      en: "Hotline: 400-820-6925",
    },
    p1: {
      cn: "战略投资伙伴",
      en: "Strategic Investors",
    },
    p2: {
      cn: "产品概览",
      en: "Product Overview",
    },
    p3: {
      cn: "智能充电解决方案",
      en: "Smart Charging Solution",
    },
    p4: {
      cn: "产品介绍",
      en: "Product Introduction",
    },
    p5: {
      cn: "服务概览",
      en: "Service Overview",
    },
    p6: {
      cn: "案例介绍",
      en: "Business Cases",
    },
    p7: {
      cn: "企业资质",
      en: "Qualifications",
    },
  },
  page1: {
    w1: {
      cn: "世纪云安—低碳出行服务商",
      en: "Aurigin — Low-Carbon Mobility Service Provider",
    },
    w2: {
      cn: "集社区充电、快充储能、电池延保和梯次利用于一体的新能源汽车服务平台",
      en: "A new energy vehicle service platform integrating community charging, fast-charging energy storage, battery extended warranty and echelon utilization",
    },
    w3: {
      cn: "累计充电量",
      en: "Cumulative Charging Energy",
    },
    w4: {
      cn: "服务用户数",
      en: "Users Served",
    },
    w5: {
      cn: "服务城市数",
      en: "Cities Served",
    },
  },
  page2: {
    title: {
      cn: "关于我们",
      en: "About Us",
    },
    titleSub: {
      cn: "About Us",
      en: "关于我们",
    },
    companyName: {
      cn: "无锡世纪云安新能源有限公司",
      en: "Aurigin New Energy",
    },
    companyDesc: {
      cn: "无锡世纪云安新能源有限公司是中国领先的新能源汽车充电服务解决方案运营商。公司积极响应国家 “十五五” 绿色低碳发展战略部署，打造 “AI+” 数智化充电管理体系，依托智能技术、专业管理、精细运营、优质服务，为各类用户提供安全、便捷的充电解决方案，满足不同类型用户的充电实际需求，助力国家 “双碳” 目标实现。",
      en: `Aurigin New Energy is a leading operator of new energy vehicle charging service solutions. Aurigin actively responds to the national "15th Five-Year Plan" green and low-carbon development strategy, builds an "AI+" digital and intelligent charging management system, and relies on intelligent technology, professional management, refined operations, and high-quality services to provide safe and convenient charging solutions for various users, meet the actual charging needs of different types of users, and help achieve the national "dual carbon" goals.`,
    },
    timeline: [
      {
        title: { cn: "2012～2016年", en: "2012 - 2016" },
        items: [
          {
            cn: "全国首家新能源汽车多品牌4S店",
            en: "China's first multi-brand NEV 4S store",
          },
          {
            cn: "建立全国首个标准化充电安装服务体系及系统",
            en: "Built China's first standardized charging installation service system",
          },
          {
            cn: "投资运营全国首个社区充电站",
            en: "Invested & operated China's first community charging station",
          },
        ],
      },
      {
        title: { cn: "2017～2020年", en: "2017 - 2020" },
        items: [
          {
            cn: "达成与滴滴平台合作",
            en: "Partnered with DiDi platform",
          },
          {
            cn: "研发集群充电系统 ",
            en: "Developed clustered charging system",
          },
          {
            cn: "落地宁波首个储能快充站",
            en: "Launched Ningbo's first energy-storage fast-charging station",
          },
        ],
      },
      {
        title: { cn: "2021～2022年", en: "2021 - 2022" },
        items: [
          {
            cn: "创立淘淘充品牌，深耕社区充电服务",
            en: "Founded Tao Charge, focusing on community charging services",
          },
          {
            cn: "联合国 WIPO GREEN",
            en: "Partner of UN WIPO GREEN",
          },
          {
            cn: "落地北京首个 “统建统营” 示范小区",
            en: 'Beijing\'s first "unified construction and operation" demonstration community',
          },
          {
            cn: "上海市共享充电桩示范性小区",
            en: "Shanghai shared charging pile demonstration community",
          },
        ],
      },
      {
        title: { cn: "2023年", en: "2023" },
        items: [
          {
            cn: "淘淘充与益虫重组",
            en: "Aurigin merged with Yichong",
          },
          {
            cn: "主编《居住社区电动汽车智能充电设施设计规范》",
            en: 'Led compilation of "Design Specification for Smart Charging Facilities for Electric Vehicles in Residential Areas"',
          },
          {
            cn: "编写《居住区充电基础设施建设指南》",
            en: 'Drafted "Guide for the Construction of Charging Infrastructure in Residential Areas"',
          },
        ],
      },
      {
        title: { cn: "2024～2025年", en: "2024 - 2025" },
        items: [
          {
            cn: "公司达成 A+ 轮数亿元融资",
            en: "Completed hundreds of millions RMB Series A+ financing",
          },
          {
            cn: "与杭州滨江物业战略合作，覆盖其所辖住宅、园区、写字楼，分批投建4,000台充电设备",
            en: "Strategic partnership with Hangzhou Binjiang Property; phased construction of 4,000 charging devices",
          },
        ],
      },
      {
        title: { cn: "2026年", en: "2026" },
        items: [
          {
            cn: "覆盖主要一、二线城市，投建运营充电桩超30万台；",
            en: "Covers major Tier 1 & 2 cities; 300,000+ operational charging piles",
          },
          {
            cn: "与设备厂商易电及全球运营商skyvolt深度合作，构建新能源汽车充电产业服务体系",
            en: "Deep cooperation with Yidian & Skyvolt to build NEV charging service system",
          },
        ],
      },
    ],
  },
  page3: {
    title: {
      cn: "业务规模",
      en: "Business Scale",
    },
    titleSub: {
      cn: "Business Scale",
      en: "业务规模",
    },
    efficiencyTitle: {
      cn: "运营效率",
      en: "Operational Efficiency",
    },
    effP1: {
      cn: [{ t: "行业平均水平" }, { hl: "两倍" }, { t: "以上" }],
      en: [
        { t: "More than " },
        { hl: "twice" },
        { t: " the industry average" },
      ],
    },
    effP2: {
      cn: [
        { t: "交流充电桩平均利用率" },
        { hl: "15%" },
        { t: "，直流充电桩平均利用率 " },
        { hl: "30%" },
      ],
      en: [
        { t: "Average utilization of AC piles: " },
        { hl: "15%" },
        { t: "; DC piles: " },
        { hl: "30%" },
      ],
    },
    effP3: {
      cn: "交流桩站点单桩月度充电量最高可达1200度",
      en: "Monthly charging volume per AC pile reaches up to 1200 kWh",
    },
    effP4: {
      cn: "直流桩站点单桩月度充电量最高可达120000度",
      en: "Monthly charging volume per DC pile reaches up to 120,000 kWh",
    },
    stats: [
      { cn: "服务城市", en: "Cities Served" },
      { cn: "服务社区数", en: "Communities Served" },
      { cn: "自营充电桩数", en: "Self-operated Piles" },
      { cn: "加盟充电桩数", en: "Franchised Piles" },
      { cn: "平台用户数", en: "Platform Users" },
    ],
  },
  page4: {
    leftTitle1: {
      cn: "世纪金源集团",
      en: "世纪金源集团",
    },
    leftTitle2: {
      cn: "GOLDEN RESOURCES GROUP",
      en: "GOLDEN RESOURCES GROUP",
    },
    leftTitle3: {
      cn: "大消费｜大健康｜新科技",
      en: "Consumer & Lifestyle | Healthcare & Wellness | Technology & Innovation",
    },
    cardP1: {
      cn: "战略投资伙伴",
      en: "Strategic Investment Partner",
    },
    cardP2: {
      cn: "Strategic investment partner",
      en: "战略投资伙伴",
    },
    cardP3: {
      cn: "世纪金源集团",
      en: "世纪金源集团",
    },
    cardP4: {
      cn: "GOLDEN RESOURCES GROUP",
      en: "GOLDEN RESOURCES GROUP",
    },
    visionTitle: {
      cn: "集团概况",
      en: "Group Overview",
    },
    visionDesc: {
      cn: "1991 年成立，是综合性跨行业国际企业集团，多年荣登 “中国企业 500 强” 和 “中国服务业 500 强” 榜单。集团以 “平台 + 投资” 为战略，拥有商业运营、地产开发、酒店文旅、生活服务、大健康、智慧出行等支柱产业，并在儿童、教育、金融服务、AI 科技、新能源、矿业等领域投资布局，形成 “大消费、大健康、新科技” 三大主航道业务。",
      en: 'Founded in 1991, Golden Resources Group is a comprehensive cross-industry international enterprise group that has been listed among the "Top 500 Enterprises of China" and "Top 500 Service Enterprises of China" for many years. With a "platform + investment" strategy, the group owns pillar businesses including commercial operations, real estate development, hotels & culture-tourism, lifestyle services, healthcare and smart mobility, and has invested in children\'s services, education, financial services, AI technology, new energy, mining and other sectors, forming three main business tracks: consumer & lifestyle, healthcare & wellness and technology & innovation.',
    },
  },
  page5: {
    items: [
      {
        title: {
          cn: "大消费",
          en: "Consumer & Lifestyle",
        },
        sub: {
          cn: "聚集消费者，赋能产业升级",
          en: "Focusing on consumer & lifestyle to empower industrial upgrading",
        },
        paras: [
          {
            cn: "依托幸福产业生态圈资源，采用 “深度产业运营 + 产业投资” 模式，依托消费升级机遇，布局新场景、新业态、新品牌项目，搭建产业价值网与智慧供应链，促进内部资源协同，创造新增价值。",
            en: 'Leveraging the happiness-industry ecosystem resources and a "deep industrial operation + industrial investment" model, the group seizes consumption-upgrade opportunities to develop new scenarios, new business formats and new brand projects, builds an industrial value network and smart supply chain, and promotes internal resource synergy to create incremental value.',
          },
        ],
      },
      {
        title: {
          cn: "大健康",
          en: "Healthcare & Wellness",
        },
        sub: {
          cn: "布局大健康，把握产业风口",
          en: "Positioning in healthcare & wellness to seize the industry trend",
        },
        paras: [
          {
            cn: "伴随人口老龄化与国民健康需求提升，世纪金源布局大健康赛道，以腾云大健康整合全产业链，打造腾云 TWing 运营投资平台，致力成为国内领先的健康管理、医疗康养资源整合服务商，守护居民健康幸福生活。",
            en: "Along with population aging and rising national health demands, Century Golden Resources has entered the healthcare & wellness sector, integrating the whole industry chain through Tengyun Great Health and building the TWing operation and investment platform, striving to become a leading domestic service provider of health management and medical & elderly-care resource integration, safeguarding residents' healthy and happy lives.",
          },
        ],
      },
      {
        title: {
          cn: "新科技",
          en: "Technology & Innovation",
        },
        sub: {
          cn: "投资 AI 科技，驭领产业未来",
          en: "Investing in AI technology to lead the industrial future",
        },
        paras: [
          {
            cn: "把握数字产业革命机遇，世纪金源以腾云资本为平台，通过股权投资布局 AI、新基建、智慧出行等赛道。旗下世纪云安为智慧出行核心企业，专注新能源智能充电运营，助力绿色低碳发展。",
            en: "Seizing the opportunities of the digital industrial revolution, the group uses Tengyun Capital as a platform to invest in AI, new infrastructure, smart mobility and other sectors through equity investment. Aurigin (世纪云安), a group member and core enterprise in smart mobility, focuses on smart charging operations for new energy vehicles, contributing to green and low-carbon development.",
          },
        ],
      },
    ],
  },
  page6: {
    title: {
      cn: "产品概览",
      en: "Product Overview",
    },
    titleSub: {
      cn: "Product Overview",
      en: "产品概览",
    },
    groups: [
      {
        title: { cn: "交流充电产品", en: "AC Charging Products" },
        items: [
          { cn: "单相交流充电桩", en: "Single-phase AC charging pile" },
          { cn: "三相交流充电桩", en: "Three-phase AC charging pile" },
          { cn: "集群充电系统", en: "Cluster charging system" },
          { cn: "能源路由器", en: "Energy router" },
        ],
      },
      {
        title: { cn: "直流充电产品", en: "DC Charging Products" },
        items: [
          {
            cn: "30kW-180kW单枪直流充电桩",
            en: "30kW-180kW single-connector DC pile",
          },
          {
            cn: "60kW-360kW双枪直流充电桩",
            en: "60kW-360kW dual-connector DC pile",
          },
          {
            cn: "30kW-480kW智能分配系统",
            en: "30kW-480kW smart power distribution system",
          },
          {
            cn: "480kW-960kW智能分配系统",
            en: "480kW-960kW smart power distribution system",
          },
        ],
      },
      {
        title: { cn: "储充一体系统", en: "Energy Storage System" },
        items: [
          {
            cn: "60kW-180kW/60kWh-90kWh储充一体系统(分体机)",
            en: "60kW-180kW/60kWh-90kWh storage fast",
          },
          {
            cn: "60kW-180kW/100kWh-216kWh储充一体系统(分体机)",
            en: "60kW-180kW/100kWh-216kWh storage fast",
          },
          {
            cn: "240kW/250kWh储充一体系统(一体机)",
            en: "240kW/250kWh storage fast",
          },
          {
            cn: "450kW/330kWh储充一体系统(一体机)",
            en: "450kW/330kWh storage fast",
          },
          {
            cn: "480kW/960kWh储充一体系统(一体机)",
            en: "480kW/960kWh storage fast",
          },
        ],
      },
      {
        title: { cn: "云端服务产品", en: "Cloud Service Products" },
        items: [
          {
            cn: "充电设施通信平台",
            en: "Charging facility communication platform",
          },
          {
            cn: "充电设施运营支持平台",
            en: "Charging facility operation support platform",
          },
          {
            cn: "淘淘充小程序（To C）",
            en: "Tao Charge mini program (To C)",
          },
          { cn: "淘淘充移动端（To C）", en: "Tao Charge mobile app (To C)" },
          {
            cn: "充电运营SAAS平台（To B）",
            en: "Charging operation SaaS platform (To B)",
          },
        ],
      },
    ],
  },
  page7: {
    title: {
      cn: "智能充电解决方案",
      en: "Smart Charging Solution",
    },
    titleSub: {
      cn: "Smart Charging Solution",
      en: "智能充电解决方案",
    },
  },
  page8: {
    title: {
      cn: "产品介绍",
      en: "Product Introduction",
    },
    titleSub: {
      cn: "Product Overview",
      en: "产品介绍",
    },
    products: [
      {
        name: {
          cn: "淘淘充7KW交流充电桩",
          en: "Aurigin 7KW AC Charging Pile",
        },
        specName: {
          cn: "技术参数",
          en: "Technical Specifications",
        },
        rows: [
          [
            { cn: "输入电压：220V±20%", en: "Input voltage: 220V±20%" },
            { cn: "输出电压：220V±20%", en: "Output voltage: 220V±20%" },
          ],
          [
            { cn: "额定电流：32A", en: "Rated current: 32A" },
            { cn: "额定功率：7kW", en: "Rated power: 7kW" },
          ],
          [
            { cn: "工作频率：50Hz", en: "Operating frequency: 50Hz" },
            { cn: "防护等级：IP55", en: "Ingress protection: IP55" },
          ],
          [
            {
              cn: "工作温度：-25℃~50℃",
              en: "Operating temperature: -25°C~50°C",
            },
            {
              cn: "环境湿度：5%~95%（无凝结）",
              en: "Ambient humidity: 5%~95%, non-condensing",
            },
          ],
          [
            { cn: "海拔高度：≤2000m", en: "Max altitude: ≤2000m" },
            { cn: "显示方式：指示灯", en: "Display: indicator light" },
          ],
        ],
      },
      {
        name: {
          cn: "淘淘充60KW双枪版一体式直流充电桩",
          en: "Aurigin 60kW Dual-Gun Integrated DC Charging Pile",
        },
        specName: {
          cn: "技术参数",
          en: "Technical Specifications",
        },
        rows: [
          [
            { cn: "额定功率：60kW", en: "Rated power: 60kW" },
            {
              cn: "设备尺寸：1620*750*560mm",
              en: "Dimensions: 1620*750*560mm",
            },
          ],
          [
            { cn: "输入电压：AC380V±15%", en: "Input voltage: AC380V±15%" },
            { cn: "输入频率：50±1Hz", en: "Input frequency: 50±1Hz" },
          ],
          [
            { cn: "输出电压：200-750VDC", en: "Output voltage: 200-750VDC" },
            { cn: "输出电流：5-200A", en: "Output current: 5-200A" },
          ],
          [
            { cn: "线缆长度：5m", en: "Cable length: 5m" },
            { cn: "联网方式：以太网/4G", en: "Networking: Ethernet/4G" },
          ],
          [
            {
              cn: "工作温度：-20℃～+50℃",
              en: "Operating temperature: -20°C~+50°C",
            },
            {
              cn: "工作湿度：5%~95%无凝霜",
              en: "Operating humidity: 5%~95%, non-condensing",
            },
          ],
          [
            { cn: "工作海拔：<2000m", en: "Operating altitude: <2000m" },
            { cn: "防护等级：IP54", en: "Ingress protection: IP54" },
          ],
          [
            {
              cn: "充电方式：刷卡充电/扫码充电/密码充电",
              en: "Charging methods: Card / QR code / Password",
            },
          ],
          [
            {
              cn: "执行标准：GB/T20234、GB/T18487、GB/T27930、NB/T33008、NB/T33002",
              en: "Standards: GB/T 20234 / GB/T 18487 / GB/T 27930 / NB/T 33008 / NB/T 33002",
            },
          ],
        ],
      },
      {
        name: {
          cn: "淘淘充480KW柔性充电堆",
          en: "Aurigin 480kW Flexible Charging Stack",
        },
        specName: {
          cn: "技术参数",
          en: "Technical Specifications",
        },
        rows: [
          [
            { cn: "额定功率：480kW", en: "Rated power: 480kW" },
            {
              cn: "输入电压：AC323V~AC437V",
              en: "Input voltage: AC323V~AC437V",
            },
          ],
          [
            { cn: "输入电流：≤912A", en: "Input current: ≤912A" },
            {
              cn: "输出电压：DC150~1000V（恒功率范围300~1000V）",
              en: "Output voltage: DC150~1000V (constant power range 300~1000V)",
            },
          ],
          [
            {
              cn: "输出电流：1600A（系统）",
              en: "Output current: 1600A (system)",
            },
            { cn: "输出路数：8", en: "Output channels: 8" },
          ],
          [
            {
              cn: "启动方式：本地、扫码、刷卡（选配）、VIN（选配）",
              en: "Start modes: Local / QR code / Card (optional) / VIN (optional)",
            },
            {
              cn: "通信接口：4G全网通 / 以太网",
              en: "Communication: 4G (all-netcom) / Ethernet",
            },
          ],
          [
            {
              cn: "主机尺寸（W*D*H）：1400*910*1800mm（8枪）",
              en: "Host dimensions (W*D*H): 1400*910*1800mm (8 guns)",
            },
            {
              cn: "充电枪长度：柜外5米",
              en: "Gun cable length: 5m outside the cabinet",
            },
          ],
          [
            {
              cn: "终端尺寸（W*D*H）：500*280*1455mm",
              en: "Terminal dimensions (W*D*H): 500*280*1455mm",
            },
            { cn: "防护等级：IP54", en: "Ingress protection: IP54" },
          ],
          [
            {
              cn: "工作环境：-20~50℃（50~65℃功率降额）；5%~95%（无凝露）",
              en: "Operating environment: -20~50°C (power derating at 50~65°C); 5%~95% RH, non-condensing",
            },
            {
              cn: "海拔高度：2000m（2000~4000m降额）",
              en: "Altitude: 2000m (derating at 2000~4000m)",
            },
          ],
        ],
      },
    ],
  },
  page9: {
    title: {
      cn: "服务概览",
      en: "Service Overview",
    },
    titleSub: {
      cn: "Service Overview",
      en: "服务概览",
    },
    services: [
      {
        title: { cn: "网点拓展", en: "Network Expansion" },
        items: [
          { cn: "城市准入分析", en: "City access analysis" },
          {
            cn: "城市充电站整体规划",
            en: "Overall city charging station planning",
          },
          {
            cn: "城市充电站选址标准化",
            en: "Standardized site selection for charging stations",
          },
          {
            cn: "城市停车场资源洽谈及签约",
            en: "Negotiation and contracting of parking resources",
          },
        ],
      },
      {
        title: { cn: "安装建设", en: "Installation & Construction" },
        items: [
          {
            cn: "全国性安装建设能力",
            en: "Nationwide installation capability",
          },
          { cn: "标准化安装建设流程", en: "Standardized installation process" },
          {
            cn: "标准化充电场站设计",
            en: "Standardized charging station design",
          },
        ],
      },
      {
        title: { cn: "流量运营", en: "Traffic Operation" },
        items: [
          {
            cn: "精准选址确保基础流量",
            en: "Precise site selection ensures baseline traffic",
          },
          {
            cn: "优质服务保证流量粘度",
            en: "Quality services ensure user stickiness",
          },
          {
            cn: "线上线下流量整合带来增量流量",
            en: "Online-offline traffic integration drives incremental growth",
          },
        ],
      },
      {
        title: { cn: "设备运维", en: "Equipment O&M" },
        items: [
          {
            cn: "云平台实时监控充电站状态",
            en: "Real-time cloud monitoring of charging stations",
          },
          {
            cn: "五年以上经验的充电桩运维团队",
            en: "O&M team with 5+ years of experience",
          },
          {
            cn: "四万个充电桩运维经验",
            en: "Experience in maintaining 40,000 charging piles",
          },
        ],
      },
      {
        title: { cn: "投资持有", en: "Investment & Holding" },
        items: [
          { cn: "合作模式灵活", en: "Flexible cooperation models" },
          { cn: "多种融资渠道", en: "Multiple financing channels" },
          {
            cn: "城市充电站选址标准化",
            en: "Standardized site selection for charging stations",
          },
          {
            cn: "城市停车场资源洽谈及签约",
            en: "Negotiation and contracting of parking resources",
          },
        ],
      },
    ],
  },
  page10: {
    title: {
      cn: "案例介绍",
      en: "Business Cases",
    },
    titleSub: {
      cn: "Business Case",
      en: "案例介绍",
    },
    cases: [
      {
        title: { cn: "深圳-领袖花园", en: "Shenzhen - Lingxiu Garden Station" },
        desc: {
          cn: "领航城・领秀花园位于深圳宝安航城街道，小区总户数 1962 户。我司承接小区充电桩建设，完成车库规划、配电改造、设备安装、平台调试及运维，落地 125 套充电桩，为业主提供安全便捷充电服务，助力打造绿色智慧社区。",
          en: "Linghangcheng Lingxiu Garden in Shenzhen has 1,962 households. Tao Charge delivered garage planning, power renovation, installation and O&M, deploying 125 charging piles for residents to build a green smart community.",
        },
      },
      {
        title: {
          cn: "上海-嘉誉云景",
          en: "Shanghai - Jiayu Yunjing Station",
        },
        desc: {
          cn: "项目采用快充搭配储能的创新充电模式。免去传统电力扩容的高额投入，缩短施工周期，依托能源管理系统削峰填谷，提升运营效益。同时可动态调节充电功率，支持超快充，兼顾建设成本与用户快速充电体验。",
          en: "This station adopts fast charging + energy storage. It cuts power expansion costs and construction time. The EMS enables peak shaving & valley filling with adjustable power for ultra-fast charging, balancing cost and user experience.",
        },
      },
      {
        title: {
          cn: "北京-世纪金源大饭店",
          en: "Beijing - Century Golden Resources Grand Hotel Station",
        },
        desc: {
          cn: "世纪金源大饭店地处海淀核心片区，是集商业、餐饮、休闲及五星级酒店的综合体，场地由淘淘充投资建设运营的配套充电站获评北京市首批精品示范区项目，站内含多品牌充电设备，共计配置 34 把直流充电枪。",
          en: "Located in core Haidian, Century Golden Resources Hotel is a five-star complex. Tao Charge built and runs its supporting charging station, one of Beijing's first premium demo projects, fitted with multi-brand equipment and 34 DC charging guns.",
        },
      },
      {
        title: {
          cn: "北京-万国城MOMA ",
          en: "Beijing - Wanguocheng MOMA Station",
        },
        desc: {
          cn: "万国城 MOMA 紧邻北京东二环，属于高端住宅商业综合项目。场站内由淘淘充投资建设并运营的地面充电站，配置 18 把直流充电枪。场站整体运营表现突出，运营收益长期稳居北京市同类型充电场站第一梯队。",
          en: "Wanguocheng MOMA, adjacent to Beijing's East Second Ring Road, is a high-end residential and commercial complex. The ground charging station invested, built and operated by Aurigin has 18 DC charging guns, with revenue long ranking top-tier among similar stations in Beijing.",
        },
      },
      {
        title: {
          cn: "北京-通投悦居",
          en: "Beijing - Tongtou Yueju Station",
        },
        desc: {
          cn: "通投悦居为北京通州区首个获保障性租赁住房认定书的试点项目。项目分五个片区，共设 2000 余个车位。首期由淘淘充建设运营充电桩 100 台，补齐社区基础充电配套，满足居民新能源车日常充电需求。",
          en: "Tongtou Yueju is the first pilot project in Tongzhou District, Beijing certified for affordable rental housing. Planned into five zones with over 2,000 parking spaces, its first phase delivered 100 charging piles built and operated by Aurigin, meeting residents' daily charging needs.",
        },
      },
    ],
  },
  page11: {
    title: {
      cn: "合作伙伴",
      en: "Partners",
    },
    titleSub: {
      cn: "Business Partner",
      en: "合作伙伴",
    },
    tabs: {
      oem: { cn: "主机厂", en: "Automakers" },
      platform: { cn: "出行平台", en: "Mobility Platforms" },
      property: { cn: "物业公司", en: "Property Companies" },
      strategic: { cn: "战略合作方", en: "Strategic Partners" },
    },
  },
  page12: {
    title: {
      cn: "企业资质",
      en: "Enterprise Qualifications",
    },
    titleSub: {
      cn: "Enterprise Qualifications",
      en: "企业资质",
    },
    tabs: {
      professional: { cn: "专业资质", en: "Professional Qualifications" },
      industry: { cn: "行业资质", en: "Industry Memberships" },
      patent: { cn: "软著和专利", en: "Software & Patents" },
    },
    quals: {
      q1: { cn: "安全生产许可证", en: "Work Safety License" },
      q2: {
        cn: "建筑业企业资质证书",
        en: "Construction Enterprise Qualification Certificate",
      },
      q3: { cn: "ISO质量体系认证", en: "ISO Quality System Certification" },
      q4: { cn: "莱茵认证", en: "TÜV Rheinland Certification" },
      q5: {
        cn: "上海充电桩联盟会员单位",
        en: "Shanghai Charging Pile Alliance Member",
      },
      q6: {
        cn: "上海物业协会会员单位",
        en: "Shanghai Property Management Association Member",
      },
      q7: {
        cn: "北京物业协会会员单位",
        en: "Beijing Property Management Association Member",
      },
      q8: {
        cn: "深圳停车场协会会员单位",
        en: "Shenzhen Parking Association Member",
      },
      q18: { cn: "检验报告", en: "Inspection Report" },
      q19: { cn: "高新技术企业", en: "High-Tech Enterprise" },
      q20: {
        cn: "充电设施设计规范",
        en: "Charging Facility Design Specification",
      },
      q21: {
        cn: "环境管理体系认证",
        en: "Environmental Management System Certification",
      },
      q22: {
        cn: "管理体系认证",
        en: "Management System Certification",
      },
      q23: {
        cn: "中国电力企业联合会会员单位",
        en: "Member of China Electricity Council",
      },
      q24: {
        cn: "2024胡润中国新能源潜力企业百强榜",
        en: "Hurun China New Energy Potential Companies Top 100, 2024",
      },
      q25: {
        cn: "中国节能协会节能服务产业委员会会员单位",
        en: "Member of the Energy Service Industry Committee, China Energy Conservation Association",
      },
      q26: { cn: "发明专利", en: "Invention Patent" },
      q27: {
        cn: "光伏电力分析调控系统",
        en: "PV Power Analysis and Dispatch System",
      },
      q28: {
        cn: "淘淘充储充管理平台",
        en: "Aurigin Storage & Charging Management Platform",
      },
      q29: {
        cn: "淘淘充智能控制调配系统",
        en: "Aurigin Intelligent Control & Dispatch System",
      },
      q30: { cn: "外观设计专利", en: "Design Patent" },
      q31: { cn: "实用新型专利", en: "Utility Model Patent" },
      q32: {
        cn: "充电设备安装管理系统",
        en: "Charging Equipment Installation Management System",
      },
      q33: {
        cn: "充电导航服务应用软件",
        en: "Charging Navigation Service Application Software",
      },
      q34: {
        cn: "充电微信小程序软件",
        en: "Charging WeChat Mini Program Software",
      },
      q35: {
        cn: "充电设备安装管理APP",
        en: "Charging Equipment Installation Management APP",
      },
      q36: {
        cn: "充电服务站点自助管理系统",
        en: "Charging Service Station Self-Service Management System",
      },
      q37: {
        cn: "益虫营销云平台",
        en: "Yichong Marketing Cloud Platform",
      },
    },
    footer: {
      slogan: {
        cn: "世纪云安 低碳出行服务商",
        en: "Aurigin — Low-Carbon Mobility Service Provider",
      },
      website: { cn: "官方网站：", en: "Official Website: " },
      email: { cn: "服务邮箱：", en: "Service Email: " },
      hotline: { cn: "服务热线：", en: "Service Hotline: " },
      icp: {
        cn: "沪ICP备15000733号-1",
        en: "Shanghai ICP License No. 15000733-1",
      },
    },
  },
};
